var _path, _path2, _ellipse, _path3, _path4, _rect, _path5, _rect2, _ellipse2, _rect3, _rect4, _rect5, _ellipse3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptySubtasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1185 140.267C110.922 140.267 138.325 113.165 138.325 79.7335C138.325 46.3019 110.922 19.2002 77.1185 19.2002C43.3151 19.2002 15.9121 46.3019 15.9121 79.7335C15.9121 113.165 43.3151 140.267 77.1185 140.267Z",
    fill: "#F4F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.927 118.321C130.485 118.125 131.072 117.863 131.524 117.485C132.062 117.036 132.28 116.457 132.427 115.848C132.616 115.066 132.691 114.232 132.92 113.449C133.004 113.158 133.167 113.048 133.237 112.999C133.414 112.876 133.592 112.843 133.76 112.855C133.959 112.869 134.233 112.944 134.412 113.274C134.438 113.321 134.471 113.393 134.494 113.492C134.51 113.564 134.521 113.79 134.538 113.883C134.581 114.113 134.618 114.342 134.652 114.573C134.765 115.341 134.83 115.994 135.187 116.699C135.672 117.657 136.158 118.244 136.817 118.503C137.455 118.754 138.216 118.707 139.19 118.51C139.283 118.488 139.374 118.469 139.465 118.453C139.894 118.379 140.305 118.658 140.389 119.081C140.473 119.503 140.2 119.915 139.775 120.008C139.686 120.027 139.599 120.046 139.512 120.063C138.197 120.385 136.674 121.534 135.789 122.541C135.516 122.851 135.116 123.719 134.709 124.273C134.408 124.681 134.07 124.95 133.787 125.045C133.597 125.109 133.436 125.099 133.304 125.067C133.112 125.02 132.952 124.917 132.83 124.753C132.763 124.663 132.701 124.543 132.671 124.39C132.657 124.316 132.656 124.128 132.656 124.043C132.573 123.761 132.471 123.485 132.397 123.2C132.221 122.52 131.874 122.089 131.463 121.521C131.078 120.988 130.664 120.654 130.058 120.387C129.979 120.368 129.343 120.214 129.118 120.125C128.79 119.996 128.633 119.779 128.577 119.662C128.48 119.463 128.47 119.29 128.49 119.145C128.518 118.932 128.615 118.749 128.787 118.602C128.893 118.51 129.052 118.421 129.265 118.378C129.429 118.344 129.866 118.324 129.927 118.321ZM133.66 117.213C133.689 117.278 133.721 117.343 133.754 117.409C134.464 118.812 135.259 119.596 136.224 119.976L136.257 119.988C135.611 120.462 135.026 120.993 134.579 121.501C134.395 121.71 134.152 122.145 133.888 122.59C133.649 121.822 133.258 121.278 132.766 120.598C132.391 120.079 131.997 119.689 131.513 119.37C131.889 119.18 132.247 118.957 132.559 118.696C133.078 118.262 133.421 117.759 133.66 117.213Z",
    fill: "#9B8AFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.69858,
    cy: 67.9377,
    rx: 2.89878,
    ry: 2.86691,
    fill: "#9B8AFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0273 35.0366C28.6372 34.7875 28.1153 34.8986 27.8643 35.2886L27.8213 35.3638C27.6259 35.7446 27.7505 36.2172 28.1172 36.4517H28.1182C30.3327 37.8651 31.7745 39.8179 32.5088 42.3218C32.6383 42.769 33.108 43.0219 33.5537 42.8931H33.5547C33.9983 42.7638 34.2604 42.298 34.1279 41.8501L33.959 41.314C33.0638 38.6681 31.4345 36.5737 29.0273 35.0366Z",
    fill: "#1D2C3B",
    stroke: "#1D2C3B",
    strokeWidth: 0.533333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5601 33.4922C65.122 31.7208 60.2294 33.3968 57.7847 37.4668C57.4125 37.1324 57.0201 36.8194 56.6118 36.5312L56.1646 36.2334C51.4766 33.2848 44.8671 34.4715 39.8062 39.1973C38.9627 39.9853 38.3066 41.1356 37.7993 42.4912C37.2911 43.8494 36.9252 45.4315 36.6743 47.1025L36.5747 47.8115C36.1809 50.8205 36.1075 54.0649 36.1313 56.7227C35.589 55.4584 34.9818 54.2276 34.3364 53.001C31.048 46.7528 27.8132 40.0982 22.3628 35.2861L22.3618 35.2852C22.0134 34.9802 21.4819 35.0094 21.1733 35.3564L21.1187 35.4238C20.867 35.7702 20.9182 36.2561 21.2437 36.5439C26.4979 41.1841 29.6011 47.6216 32.8423 53.7812C33.8565 55.7083 34.7652 57.6305 35.4673 59.6777L35.4683 59.6787C35.6817 60.2964 35.8953 60.8985 36.0728 61.5146C36.0732 61.5175 36.0733 61.5234 36.0737 61.5332C36.0744 61.55 36.0745 61.5717 36.0728 61.6006C36.071 61.6302 36.068 61.6611 36.0649 61.6982C36.0621 61.7332 36.0595 61.773 36.0581 61.8135V61.8164C36.0534 62.0179 36.0615 62.2335 36.106 62.4033V62.4053C36.1898 62.7156 36.377 62.9318 36.6118 63.0547H36.6128C36.7849 63.1435 36.9985 63.1929 37.2544 63.1475L37.2573 63.1465C37.4388 63.1122 37.7306 63.0104 37.8872 62.6406V62.6396C37.9058 62.5958 37.9164 62.5442 37.9233 62.5059C37.9319 62.4583 37.9404 62.3997 37.9468 62.3311C37.9597 62.1928 37.9674 62.0064 37.9614 61.7773L37.8843 59.7119C37.79 57.0023 37.7055 52.5869 38.186 48.5283C38.3915 46.7909 38.6901 45.1274 39.1392 43.7119C39.5896 42.292 40.1834 41.1488 40.9595 40.4238C45.6166 36.0753 51.6011 35.0577 55.6382 37.9033C56.1483 38.2629 56.6253 38.6657 57.0649 39.1055C56.9892 39.4997 56.9419 39.9948 56.9487 40.499C56.9564 41.0667 57.0304 41.6678 57.2153 42.1562C57.4094 42.6682 57.7288 43.08 58.1655 43.2959C58.5661 43.4943 59.0544 43.5371 59.6206 43.3174L59.8687 43.207C60.4473 42.9145 60.6552 42.354 60.6021 41.7559C60.5552 41.2097 60.2644 40.601 60.1069 40.3242C59.7871 39.7612 59.4149 39.2314 59.0044 38.7354C60.9354 35.0916 65.1258 33.5386 68.9263 35.0498L69.2983 35.208C69.7221 35.3997 70.221 35.2147 70.4165 34.7939V34.792C70.6092 34.3698 70.4233 33.8712 69.9985 33.6787L69.5601 33.4922ZM58.7114 41.2852C58.7801 41.4213 58.8548 41.598 58.897 41.7686C58.8915 41.7618 58.8819 41.7552 58.8745 41.7432C58.849 41.7015 58.8245 41.6442 58.7935 41.5625C58.761 41.4773 58.7346 41.3836 58.7114 41.2852Z",
    fill: "#1D2C3B",
    stroke: "#1D2C3B",
    strokeWidth: 0.533333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.8701,
    y: 50.6064,
    width: 105.363,
    height: 37.5645,
    rx: 12.8,
    fill: "#BDB4FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.533 65.3331C112.533 64.0076 111.459 62.9331 110.133 62.9331H79.1999C77.8744 62.9331 76.7999 64.0076 76.7999 65.3331V65.3331C76.7999 66.6586 77.8744 67.7331 79.1999 67.7331H110.133C111.459 67.7331 112.533 66.6586 112.533 65.3331V65.3331Z",
    fill: "#6938EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 69.8667,
    height: 4.8,
    rx: 2.4,
    transform: "matrix(-1 0 0 1 146.667 70.9331)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.12578,
    cy: 6.15812,
    rx: 6.12578,
    ry: 6.15812,
    transform: "matrix(-1 0 0 1 70.3105 63.5381)",
    fill: "#6938EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.7998,
    y: 82.0127,
    width: 105.363,
    height: 37.5645,
    rx: 12.8,
    fill: "#D9D6FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9331,
    y: 94.3999,
    width: 35.7333,
    height: 4.8,
    rx: 2.4,
    fill: "#6938EF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9331,
    y: 102.4,
    width: 70.4,
    height: 4.8,
    rx: 2.4,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1146,
    cy: 101.103,
    rx: 6.12578,
    ry: 6.15812,
    fill: "#6938EF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySubtasks);
export default __webpack_public_path__ + "static/media/emptySubtasks.4ae871226dbd53de908cd6de06c54613.svg";
export { ForwardRef as ReactComponent };